export class StatusMessage {
    static readonly error = "danger";
    static readonly information = "info";
    static readonly success = "success";
    static readonly warning = "warning";

    type!: string;
    body!: string;
    hide!: boolean;
}

export class FileStatusMessage extends StatusMessage {
    fileId!: string;
}
